import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';
import { reqTransform, resTransform } from './transforms';

const { baseUrl } = config;

export const fetchAPILogs = async (params) => {
  try {
    const url = `${baseUrl}/BiofuelThirdPartyIntegration/api/IProfitERP/GetAPILogs`;
    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
    }).ready;
    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err) {
    console.log('api-GetAPILogs-fetchList->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'GetAPILogs');
    throw errors;
  }
};

export const fetchExceptionLogs = async (params) => {
  try {
    const url = `${baseUrl}/BiofuelThirdPartyIntegration/api/IProfitERP/GetExceptionLogs`;
    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
    }).ready;
    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err) {
    console.log('api-GetExceptionLogs-fetchList->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'GetExceptionLogs');
    throw errors;
  }
};

export const saveUpdateVendor = async (params) => {
  try {
    const url = `${baseUrl}/BiofuelThirdPartyIntegration/api/IProfitERP/SaveUpdateVendor`;
    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
    }).ready;
    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err) {
    console.log('api-SaveUpdateVendor-fetchList->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'SaveUpdateVendor');
    throw errors;
  }
};

export const saveUpdateCustomer = async (params) => {
  try {
    const url = `${baseUrl}/BiofuelThirdPartyIntegration/api/IProfitERP/SaveUpdateCustomer`;
    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
    }).ready;
    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err) {
    console.log('api-SaveUpdateCustomer-fetchList->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'SaveUpdateCustomer');
    throw errors;
  }
};

export const saveUpdateTaxInfo = async (params) => {
  try {
    const url = `${baseUrl}/BiofuelThirdPartyIntegration/api/IProfitERP/SaveUpdateTaxInfo`;
    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
    }).ready;
    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err) {
    console.log('api-SaveUpdateTaxInfo-fetchList->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'SaveUpdateTaxInfo');
    throw errors;
  }
};

export const saveUpdateAddress = async (params) => {
  try {
    const url = `${baseUrl}/BiofuelThirdPartyIntegration/api/IProfitERP/SaveUpdateAddress`;
    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
    }).ready;
    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err) {
    console.log('api-SaveUpdateAddress-fetchList->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'SaveUpdateAddress');
    throw errors;
  }
};

export const saveUpdateInvoice = async (params) => {
  try {
    const url = `${baseUrl}/BiofuelThirdPartyIntegration/api/IProfitERP/SaveUpdateInvoice`;
    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
    }).ready;
    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err) {
    console.log('api-SaveUpdateInvoice-fetchList->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'SaveUpdateInvoice');
    throw errors;
  }
};
